import { Color } from '@diritto/common/style/color';

export const DotDividerIcon = ({
  size = 2,
  color = Color.Gray500,
  opacity = 1,
}: {
  size?: number;
  color?: string;
  opacity?: number;
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 2 2"
    fill="none"
    fillOpacity={opacity}
    xmlns="http://www.w3.org/2000/svg">
    <circle cx="1" cy="1" r="1" fill={color} />
  </svg>
);
